import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { ItemRendererDirective } from './directives/item-renderer.directive';
import { ItemRendererComponent } from './item-renderer/item-renderer.component';

export { IItemRenderer as ITableItemRenderer } from './interfaces/item-renderer.table';
export * from './item-renderers/item-renderers.module';

@NgModule({
  declarations: [ItemRendererDirective, ItemRendererComponent],
  imports: [CommonModule],
  exports: [ItemRendererComponent],
})
export class ItemRendererModule {}
